import React from 'react'
import healthcare1 from '../images/playmind1.png';
import healthcare2 from '../images/playmind2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function PlayMind() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">Play Mind </span> - Revolutionizing Custom Web Development
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="AI Web Development Platform"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Play Mind</span> – Revolutionizing Custom Web Development
                        </h1>

                        <p className="mb-3 ps-1">
                            Play Mind is an advanced, AI-powered web development platform designed to transform how businesses create and manage their digital presence.
                            It offers customized web solutions that are intuitive, scalable, and performance-driven, tailored specifically to meet the needs of each client.
                        </p>

                        <p className="mb-3 ps-1">
                            With features like intelligent design automation, AI-driven user experience optimization, real-time analytics, and seamless content management,
                            Play Mind brings a more adaptive, efficient approach to web development.
                        </p>

                        <p className="mb-3 ps-1">
                            Whether you're building a new website, enhancing an existing one, or developing a complex web application, Play Mind offers the tools to create dynamic,
                            responsive, and engaging web experiences.
                        </p>

                        <p className="mb-4 ps-1">
                            The Future of Web Development — Powered by AI.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> Play Mind – Revolutionizing Custom Web Development
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">India</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Project Scope & Technology</h4>
                        <p className="mb-3 ps-3">
                            AI-Enhanced Custom Web Platform, OpenAI, LangChain, ReactJS, Node.js, MongoDB, TailwindCSS
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Industry</h4>
                        <p className="mb-3 ps-3">EdTech / Web Solutions</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Composition</h4>
                        <p className="mb-3 ps-3">
                            1 UI/UX Designer, 2 Frontend Developers, 1 Backend Developer, 1 AI Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Work Duration</h4>
                        <p className="mb-4 ps-3">3 Months</p>

                        <p className="mb-4 ps-3">
                            Play Mind - Revolutionizing Custom Web Development offers personalized AI-powered education tools to enhance learner experience through generative content,
                            adaptive testing, and AI-based tutors. With real-time analytics and multilingual support, it helps institutions increase engagement, retention, and learner outcomes.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="AI-Driven Web Solutions"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="AI Development Process"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            Our team implemented OpenAI, LangChain, and NLP to deliver a personalized solution that can generate content,
                            understand various languages, and adapt to student performance.
                        </p>

                        <p className="mb-3 ps-1">
                            Real-time dashboards allow instructors to track performance and adjust strategies, while AI tutors handle FAQs and support.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">AI-powered lesson generation</li>
                            <li className="mb-1">Real-time progress tracking</li>
                            <li className="mb-1">Multilingual language support</li>
                            <li className="mb-1">Interactive AI-based quizzes</li>
                            <li className="mb-1">Custom curriculum builder with AI</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>
        </>
    )
}

export default PlayMind